import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import Cookies from 'js-cookie';

import * as constants from 'constants/index.js';
import CardsHeader from 'layouts/Headers/CardsHeader.js';

import TableCustom from 'views/pages/components/TableCustom';
import InputCustom from 'views/pages/components/InputCustom';

import { deletee, hasPermission, update } from 'views/policies/FunderPolicy';

import { Card, CardBody, CardHeader, Col, Container, Modal, Row } from 'reactstrap';
import { ButtonContainer } from '@pages/reusable-components/styled-components';
import IcoMoon from 'react-icomoon';
import IconSet from '@assets/selection.json';
import notify from '@utils/notify';

export default function Funder() {
  const permissions = useSelector(state => state.getState).permissions;

  const [token, setToken] = useState('');
  const [loading, setLoading] = useState(true);
  const [isNotValid, setIsNotValid] = useState(true);
  const [delay, setDelay] = useState(true);
  const [funders, setFunders] = useState([]);

  const initialFunderState = {
    id: null,
    name: '',
  };

  const resetFunderState = () => {
    setFunder(initialFunderState);
  };

  const [funder, setFunder] = useState(initialFunderState);
  const [funderModal, setFunderModal] = useState({
    show: false,
    header: '',
    division: '',
  });

  const [deleteModal, setDeleteModal] = useState({
    show: false,
    header: '',
    body: '',
    onClick: null,
  });

  const [errors, setErrors] = useState('');

  const fetchData = async () => {
    try {
      const response = await axios.get(`${constants.API_URL}/supplying-dealer`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = response.data;
      setFunders(data.data);

      setTimeout(() => {
        setDelay(true);
        setLoading(false);
      }, 500);
    } catch (error) {
      setLoading(false);
      if (axios.isCancel(error)) {
        console.log('Request canceled :: ', error);
      } else {
        console.error('error :: ', error);
        notify.warning(
          error.response && error.response.data
            ? error.response.data.message
            : error.response
              ? error.response.statusText
              : 'Error Occurred!'
        );
      }
    }
  };

  useEffect(() => {
    const grs_token = Cookies.get('grs_token');
    setToken(grs_token);
    const source = axios.CancelToken.source();

    fetchData();

    return () => {
      source.cancel();
    };
  }, []);

  const handleModalClose = () => {
    setFunderModal({ ...funderModal, show: false });
  };

  const addOrUpdateFunder = (url, successMessage) => {
    axios({
      method: funder.id ? 'PUT' : 'POST',
      url,
      headers: { Authorization: `Bearer ${token}` },
      data: funder,
    })
      .then(response => {
        handleModalClose();
        resetFunderState();
        setErrors('');
        console.log('res :: ', response.data);
        const data = response.data;
        fetchData();
        notify.success(data.message || successMessage);
      })
      .catch(error => {
        setErrors('');
        console.error('error :: ', error);
        if (error.response && error.response.status === 422) {
          setErrors(error.response.data.errors);
          return;
        }
        handleModalClose();
        notify.warning(
          error.response ? error.response.statusText : 'Error occurred!'
        );
      });
  };

  const deleteFunder = funderId => {
    axios({
      method: 'DELETE',
      url: `${constants.API_URL}/supplying-dealer/${funderId}`,
      headers: { Authorization: `Bearer ${token}` },
      data: funder,
    })
      .then(response => {
        setDeleteModal({ ...deleteModal, show: false });
        console.log('res :: ', response.data);
        const data = response.data;
        fetchData();
        notify.success(data.message);
      })
      .catch(error => {
        console.error('error :: ', error);
        setDeleteModal({ ...deleteModal, show: false });
        notify.warning(
          error.response ? error.response.statusText : 'Error occurred!'
        );
      });
  };

  return (
    <>
      <CardsHeader name="Funders" parentName="Funder Management" currentName="List" />
      <Container className="mt--5 admin-main-body" fluid>
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col xs={8}>
                    <h1 className="mb-0">Funders</h1>
                    <p className="text-sm mb-0">You can manage Funders.</p>
                  </Col>
                  <Col xs={4} className="text-right">
                    <ButtonContainer
                      onClick={() => {
                        setFunder(initialFunderState);
                        setIsNotValid(true);
                        setFunderModal({
                          ...funderModal,
                          show: true,
                          header: 'Add funder',
                          division: 'create',
                        });
                      }}
                    >
                      <i className="fa fa-plus" aria-hidden="true"></i>
                      Add funder
                    </ButtonContainer>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <TableCustom
                  loading={loading}
                  delay={delay}
                  items={funders}
                  noOverflow
                  columns={[
                    {
                      dataField: 'name',
                      text: 'Name',
                      sort: true,
                    },
                    {
                      dataField: '',
                      text: 'Action',
                      formatter: (rowContent, row) => {
                        return (
                          <>
                            {(hasPermission(permissions, 'access-vehicle-makes') ||
                              hasPermission(permissions, 'delete-vehicle-makes')) && (
                              <>
                                {update(permissions, row) && (
                                  <IcoMoon
                                    className={'cursor-pointer'}
                                    iconSet={IconSet}
                                    icon={'edit'}
                                    size={24}
                                    onClick={() => {
                                      setFunder(row);
                                      setIsNotValid(true);
                                      setFunderModal({
                                        ...funderModal,
                                        show: true,
                                        header: 'Edit funder',
                                        division: 'update',
                                      });
                                    }}
                                  />
                                )}
                                {deletee(permissions, row) && (
                                  <IcoMoon
                                    className={'cursor-pointer'}
                                    iconSet={IconSet}
                                    icon={'delete_outline'}
                                    size={24}
                                    onClick={() => {
                                      setDeleteModal({
                                        show: true,
                                        header: 'Delete funder',
                                        body: 'Are you sure you want to delete this funder?',
                                        onClick: () => deleteFunder(row.id),
                                      });
                                    }}
                                  />
                                )}
                              </>
                            )}
                          </>
                        );
                      },
                    },
                  ]}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Modal
          isOpen={funderModal.show}
          toggle={handleModalClose}
          className="modal-dialog-centered"
        >
          <div className="modal-header">
            <h6 className="modal-title main-color">{funderModal.header}</h6>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={handleModalClose}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className="modal-body">
            <InputCustom
              newLabel={`Name`}
              editValue={funder.name}
              required
              setIsNotValid={setIsNotValid}
              value={funder.name ?? ''}
              onChange={e => setFunder({ ...funder, name: e.target.value })}
              invalid={errors && errors.name ? true : false}
              errorMessage={errors.name}
            />
          </div>
          <div className="modal-footer justify-content-end">
            <ButtonContainer onClick={handleModalClose}>{`Close`}</ButtonContainer>
            <ButtonContainer
              disabled={isNotValid}
              reverse
              onClick={() =>
                funderModal.division === 'create'
                  ? addOrUpdateFunder(`${constants.API_URL}/supplying-dealer`, 'Funder added successfully.')
                  : addOrUpdateFunder(
                      `${constants.API_URL}/supplying-dealer/${funder.id}`,
                      'Funder updated successfully.'
                    )
              }
            >
              {`Save`}
            </ButtonContainer>
          </div>
        </Modal>
        <Modal
          isOpen={deleteModal.show}
          toggle={() => setDeleteModal({ show: false })}
          className="modal-dialog-centered"
        >
          <div className="modal-header">
            <h6 className="modal-title main-color">{deleteModal.header}</h6>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => setDeleteModal({ show: false })}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className="modal-body">{deleteModal.body}</div>
          <div className="modal-footer justify-content-end">
            <ButtonContainer onClick={() => setDeleteModal({ show: false })}>
              {`Close`}
            </ButtonContainer>
            <ButtonContainer reverse onClick={deleteModal.onClick}>
              {`Delete`}
            </ButtonContainer>
          </div>
        </Modal>
      </Container>
    </>
  );
}
